import { EquipmentFormValues } from '../../types';

export const STATUSES = [
  { value: 'Owner', label: 'Owner' },
  { value: 'Leased', label: 'Leased' },
  { value: 'Contracted', label: 'Contracted' }
];

export const TYPES = [
  { value: 'EARTH_MOVING', label: 'Earth Moving' },
  { value: 'FERTILIZER', label: 'Fertilizer' },
  { value: 'FORAGE_AND_HAY', label: 'Forage and Hay' },
  { value: 'HARVESTING', label: 'Harvesting' },
  { value: 'IRRIGATION', label: 'Irrigation' },
  { value: 'MANURE', label: 'Manure' },
  { value: 'MISC', label: 'Miscellaneous' },
  { value: 'PLANTER', label: 'Planter' },
  { value: 'SHOP', label: 'Shop' },
  { value: 'SPRAYER', label: 'Sprayer' },
  { value: 'TILLAGE', label: 'Tillage' },
  { value: 'TRACTOR', label: 'Tractor' },
  { value: 'TRAILER', label: 'Trailer' },
  { value: 'TRUCK', label: 'Truck' },
  { value: 'GENERICAL_VEHICLE', label: 'Generical Vehicle' }
];

export const INITIAL_VALUES: EquipmentFormValues = {
  name: '',
  type: '',
  currentStatus: '',
  currentStatusDate: undefined,
  year: undefined,
  make: undefined,
  model: undefined,
  unitId: undefined,
  serialNumber: undefined,
  licenseNumber: undefined,
  purchasePrice: undefined,
  purchaseDate: undefined,
  currentValue: undefined,
  currentValueDate: undefined,
  notes: undefined
};
